import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { inject } from '@app/providers/QAU.ContextProvider';
import { isCustomShapeFlow } from '@app/utils/utils';

import SnapToEdge from './tools/snap-to-edge/SnapToEdge';
import LockArtworkRatio from './tools/lock-artwork-ratio/LockArtworkRatio';
import ZoomTool from '@components/zoom-tool/ZoomTool';
import './TopToolPanel.scss';
import { isCreatedFromDielineShape } from '@app/utils/hints';

const TopToolPanel = ({ editorZoom, editor, snapToEdgeVisible, lockArtworkRatioEnabled }) => {
  const { minZoom = 0.05, maxZoom = 5 } = editor || {};
  const setZoomLevel = zoomValue => editor?.setZoomLevel(zoomValue);
  const scrollToCenter = () => editor?.scrollToCenter();
  const autoZoom = () => editor?.autoZoom();

  return (
    <div id="qau-top-tool-panel">
      <div className="grouped-tools">
      {snapToEdgeVisible && <SnapToEdge />}
      {lockArtworkRatioEnabled && <LockArtworkRatio />}
      </div>
      <ZoomTool
        currentZoom={editorZoom}
        minZoom={minZoom}
        maxZoom={maxZoom}
        setZoomLevel={setZoomLevel}
        scrollToCenter={scrollToCenter}
        autoZoom={autoZoom}
      />
    </div>
  );
}

const mapStateToProps = ({
  customize: {
    customizeData: { editor, editorZoom, snapToEdgeVisible },
  },
}, { flowConfig, context }) => ({
  editor,
  editorZoom,
  snapToEdgeVisible,
  lockArtworkRatioEnabled: !isCustomShapeFlow(flowConfig) && !isCreatedFromDielineShape(context),
});

TopToolPanel.propTypes = {
  editor: PropTypes.object,
  editorZoom: PropTypes.number.isRequired,
  snapToEdgeVisible: PropTypes.bool.isRequired,
  lockArtworkRatioEnabled: PropTypes.bool.isRequired,
  context: PropTypes.object.isRequired,
};

export default inject('flowConfig', 'context')(connect(mapStateToProps)(TopToolPanel));
